import { useMemo } from 'react';

import { AuditLogObject, AuditLogPane } from './AuditLogPane';
import { AuditLogFields } from './utils';

export function CollectionAuditLogPane({
  collectionId,
  onClose,
  visible,
}: {
  collectionId: string | undefined;
  onClose: () => void;
  visible: boolean;
}) {
  const auditObjects = useMemo<AuditLogObject[]>(() => {
    if (!collectionId) {
      return [];
    }
    return [{ id: collectionId, type: 'collection' }];
  }, [collectionId]);

  return (
    <AuditLogPane
      title="Collection History"
      onClose={onClose}
      visible={visible}
      fields={auditFields}
      objects={auditObjects}
      hiddenFields={hiddenFields}
      sourceLabels={{ USER: 'Marketing Collections' }}
    />
  );
}

const auditFields: AuditLogFields = {
  // Collection page fields
  'collection.name': { label: 'Name' },
  'collection.slug': { label: 'URL Slug' },
  'collection.promoName': { label: 'Promo Name' },
  'collection.warehouses': { label: 'Warehouses' },
  'collection.description': { label: 'Description' },
  'collection.mobileHeroImage': { label: 'Mobile Hero Image' },
  'collection.desktopHeroImage': { label: 'Desktop Hero Image' },
  'collection.discardedAt': { label: 'Deleted At', value: 'date' },
  'collection.itemCount': { label: 'Item Count', value: 'integer' },
  // Half-Banner fields
  'halfBanner.endDate': { label: 'Half-Banner End Date' },
  'halfBanner.position': { label: 'Half-Banner Position' },
  'halfBanner.fontStyle': { label: 'Half-Banner Font Style' },
  'halfBanner.startDate': { label: 'Half-Banner Start Date' },
  'halfBanner.warehouses': { label: 'Half-Banner Warehouses' },
  'halfBanner.mobileImage': { label: 'Half-Banner Mobile Image' },
  'halfBanner.desktopImage': { label: 'Half-Banner Desktop Image' },
  // Carousel fields
  'carousel.endDate': { label: 'Carousel End Date' },
  'carousel.position': { label: 'Carousel Position' },
  'carousel.startDate': { label: 'Carousel Start Date' },
  'carousel.warehouses': { label: 'Carousel Warehouses' },
  // Highlight Carousel fields
  'highlightCarousel.endDate': { label: 'Highlight Carousel End Date' },
  'highlightCarousel.position': { label: 'Highlight Carousel Position' },
  'highlightCarousel.startDate': { label: 'Highlight Carousel Start Date' },
  'highlightCarousel.highlightImage': { label: 'Highlight Carousel Image' },
  'highlightCarousel.warehouses': { label: 'Highlight Carousel Warehouses' },
};

const hiddenFields = new Set(['collection.updatedAt', 'collection.updatedBy']);
